<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles qualityInspection">
            <van-nav-bar
                title="故障报备"
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
            >
                <template #title>
                    <div
                        :class="{'active': listType == 'wjc'}"
                        @click="listSwitch('wjc')"
                    >
                        未检测
                    </div>
                    <div
                        :class="{'active': listType == 'yjc'}"
                        @click="listSwitch('yjc')"
                    >
                        已检测
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="value" placeholder="请输入搜索信息" @change="search"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <template v-for="(item, index) in listData">
                                <li :key="index">
                                    <div class="engineeringInfo" @click="openTestDetails(item)">
                                        <div class="select-supply-btn" @click.stop="reSelectSupply(item,index)">
                                            重选
                                        </div>
                                        <h4 class="engineeringInfo_header">
                                            <span v-if="item.result == 1" class="state" style="background:#00A84B;">
                                                <i>通过</i>
                                            </span>
                                            <span v-if="item.result == 2" class="state" style="background:#191990;">
                                                <i>让步</i>
                                            </span>
                                            <span v-if="item.result == 3" class="state" style="background:#E60000;">
                                                <i>不通过</i>
                                            </span>
                                            <span class="headerName">{{ item.balance_number }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                <span>供应单编号：{{ item.task_number }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>物料名称：{{ item.type_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>子类：{{ item.child_type_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_5.png" alt="">
                                                <span>型号：{{ item.spec_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                                <span>供应场站：{{ item.station_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                <span>供应商：{{ item.supplier_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_11.png" alt="">
                                                <span>运输单位：{{ item.transport_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_18.png" alt="">
                                                <span>车牌号：{{ item.plate_number }}</span>
                                            </p>
                                            <p class="weight">
                                                <img src="@/assets/images/icons/icon_gy_10.png" alt="">
                                                <span>毛重：{{ item.gross_weight }}吨</span>
                                                <span>皮重：{{ item.tare_weight }}吨</span>
                                                <span>扣吨：{{ item.deduction_weight }}吨</span>
                                                <span v-if="listType == 'wjc'">扣水：{{ item.deduction_water }}吨</span>
                                                <span v-else>实际含水率：{{ item.water_content }}%</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>进站时间：{{ item.gross_time }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>出站时间：{{ item.tare_time }}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="btns" v-if="listType == 'wjc'">
                                        <button @click="testing(item,index)">
                                            快检
                                        </button>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
                <van-popup
                    v-model="showTestPop"
                    closeable
                    round
                    position="bottom"
                >
                    <testForm
                        v-if="showTestPop"
                        :test-obj="listData[handleIndex]"
                        @callback="testCallback"
                    ></testForm>
                </van-popup>
            </section>
        </div>
    </v-touch>
</template>
<script>
import { eventBus } from '@/common/eventBus.ts';
import testForm from './testForm';
export default {
    // 质量监控
    name: 'quality-inspection',
    components: { testForm },
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'quality-inspection');
        }
        next();
    },
    data() {
        return {
            // 搜索条件
            value: '',
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 上拉索引
            count: 0,
            // 列表总条数
            total: 0,
            // 是否已加载完所有数据
            finished: false,
            // 当前打开列表类型，wjc未检出，yjc已检测
            listType: 'wjc',
            // 列表数据
            listData: '',
            // 快检弹出层状态
            showTestPop: false,

            // 当前操作数据得索引
            handleIndex: 0,
        };
    },
    filters: {
        itemName: function (data) {
            const newData = data.substring(data.length - 2);
            return newData;
        },
    },
    computed: {},
    activated() {},
    created() {
        eventBus.$on('updateInspectionOneData', () => {
            this.updateOneData();
        });
    },
    destroyed() {
        eventBus.$off('updateInspectionOneData');
    },
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 搜索
        search() {
            this.listData = [];
            this.gitListData();
        },
        // 下拉刷新
        onRefresh() {
            this.count = 1;
            this.listData = [];
            this.gitListData();
        },
        // 上拉加载更多
        onLoad() {
            this.count++;
            this.gitListData();
        },
        // 待办已办切换
        listSwitch(obj) {
            this.count = 1;
            this.listData = [];
            this.listType = obj;
            this.gitListData();
        },
        // 打开检测详情页
        openTestDetails(data) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'testDetails',
                params: {
                    data: data,
                },
            });
        },
        // 快检
        testing(data, index) {
            this.handleIndex = index;
            this.showTestPop = true;
        },
        // 获取列表数据
        gitListData() {
            let postType = '';
            if (this.listType === 'wjc') {
                postType = 'wjc';
            } else {
                postType = 'jyc';
            }
            this.$axios
                .get(`/interfaceApi/procurement/balance/getpage/${postType}?pageindex=${this.count}&pagesize=3&searchkey=${this.value}`)
                .then(res => {
                    if (res && res.rows.length > 0) {
                        this.total = res.PageCount;
                        if (this.listData.length < 1) {
                            this.listData = res.rows;
                            this.finished = false;
                        } else {
                            this.listData.push(...res.rows);
                        }
                        if (this.listData.length === this.total) {
                            this.finished = true;
                        }
                    } else {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                    this.$forceUpdate();
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 刷新当前操作数据
        updateOneData() {
            const balance_number = this.listData[this.handleIndex].balance_number;
            this.$axios.get('/interfaceApi/procurement/balance/get/jc?balance_number=' + balance_number)
                .then(data => {
                    this.listData.splice(this.handleIndex, 1, data);
                });
        },
        // 重新选择供应单
        reSelectSupply(item, index) {
            this.$axios.get('/interfaceApi/procurement/accounts/getcheckstatus?balance_id=' + item.id)
                .then(data => {
                    if (data === 1) {
                        this.handleIndex = index;
                        this.$router.isBack = 2;
                        this.$router.push({
                            path: '/selectSupply',
                            query: {
                                balance_number: item.balance_number,
                            },
                        });
                    } else {
                        this.$toast('过磅单已核对，不能重新选择。');
                    }
                }).catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },

        // 检测结束回调
        testCallback(type) {
            // 保存
            if (type === 1) {
                this.updateOneData();
                // 确定，提交审批
            } else if (type === 2) {
                this.listData.splice(this.handleIndex, 1);
                this.showTestPop = false;
            }
        },
    },
};
</script>
<style lang="stylus" scoped>
    .qualityInspection
        height 100%
        background #F0F0F0
        .van-nav-bar
            .van-nav-bar__title
                div
                    display inline-block
                    padding 0 15rpx
                    font-size 14rpx
                    color rgba(240,240,240,0.7)
                    transition 0.2s
                    &.active
                        font-size 18rpx
                        color #fff
        section
            height calc(100% - 45rpx)
            overflow: hidden;
            .van-pull-refresh
                height calc(100% - 45rpx)
                overflow: scroll;
                -webkit-overflow-scrolling: touch;
                .van-list
                    height 100%
                .list
                    background #F0F0F0
                    padding 15rpx
                    padding-bottom 0
                    overflow hidden
                    li
                        width 100%
                        background #fff
                        overflow hidden
                        margin-bottom 15rpx
                        position relative
                        .select-supply-btn
                            position absolute
                            top 54rpx;
                            right 20rpx;
                            padding 2rpx 6rpx;
                            border 1px solid #1989fa
                            background #fff
                            border-radius 4rpx
                            font-size 12rpx
                            color #1989fa
                        .engineeringInfo
                            p
                                &.weight
                                    text-align right
                                    img
                                        float left
                                    span
                                        float right
                                        width calc((100% - 30rpx)/2)
                                        text-align left
                            .telephone
                                width 25rpx
                                height 25rpx
                                background url(./../../../assets/images/clueManagement/phone@2x.png)
                                background-size 100% 100%
                                border none
                                position absolute
                                right 15rpx
                                bottom 0
                        .btns
                            padding 0 6rpx
                            text-align center
                            margin-bottom 14rpx
                            button
                                border 1px solid #1989fa
                                background #1989fa
                                border-radius 4rpx
                                height 32rpx
                                margin 0 10rpx
                                font-size 14rpx
                                color #fff
                                width calc((100% - 20rpx))

</style>
